<template>
    <div class="search-knowledge-box" id="search-knowledge-box">
        <div class="search-input-box flexBox">
            <div class="topic-select" @click="topicSelected = true">{{ selectedTopic }}<i></i></div>
            <form action="#" @submit.prevent class="search-box" @click="$refs.searchinput.focus()">
                <input type="search" class="search-input" ref="searchinput" v-model="keywords" maxlength="50" :placeholder="placeholder" @keyup.enter="getSearch" @focus="searchFocus" @blur="SearchBlur">
            </form>
            <i class="icon icon-searchClose search-close" v-show="keywords" @click="ClearSearch">
                <span class="path1"></span><span class="path2"></span>
            </i>
            <span class='search-btn' :class="{'search-btn-disabled':!keywords}" @click="getSearch">搜索</span>
        </div>

        <div class="search-knowledge-tip padding-sets" v-show="!actionSearch && false">
            <p class="tip-head">提示</p>
            <span class="tip-content">可以通过关键词搜索和一线服务、销售、日常办公相关的蔚来知识及常见问题</span>
        </div>


        <!-- 选择搜索类别  模块 -->
        <transition name="topic-select-mask-anim">
            <div v-if="topicSelected" class="topic-select-mask" @click="topicSelected = false"></div>
        </transition>
        <transition name="topic-select-list-wrapper-anim">
            <div class="topic-select-list-wrapper" v-if="topicSelected" @touchstart="$refs.searchinput.blur()">
                <h5 class="topic-head padding-sets">搜索指定内容<i class="close-icon" @click="topicSelected = false"></i></h5>
                <div class="list-wrapper padding-sets">
                    <div class="topic-lists">
                        <span v-for="scope in scopeLists" :key="scope.NodeId" class="topic-list-item flexBox" :class="{'topic-list-item-active': scope.NodeId == selectNodeId || (!scope.NodeId && !selectNodeId)}" v-text="scope.Name" @click="selectTopic(scope)"></span>
                    </div>
                </div>
            </div>
        </transition>


        <!-- 搜索历史   模块 -->
        <div class="search-history" v-if="!actionSearch && searchHistoryList.length">
            <h5 class="history-head">搜索历史<i class="clear-icon" @click="clearSearchHistory"></i></h5>
            <div class="history-list">
                <span v-for="(historys) in searchHistoryList" v-text="historys" class="history-list-item" @click="searchingHistory(historys)"></span>
            </div>
        </div>



        <!-- guess what you want to search for? -->
        <div class="search-result search-advice padding-sets" v-if="similarWordList.length">
            猜你想搜<span @click="Searching(similarWord)" v-for="(similarWord, index) in similarWordList" :key="index">{{ similarWord + (index === similarWordList.length-1 ? '' : '，') }}</span>
        </div>

        <!-- 知识图谱暂时砍掉 vif='false'-->
        <div class="search-result search-atlas-result padding-sets" v-if="false">
            <div class="atlas" v-html="atlas"></div>
            <div class="thumb-up-down" :class="userAction">
                <div class="thumb-up" @click="recommandThumUpDown(true)">
                    <i></i><span>有用</span>
                </div>
                <div class="thumb-down" @click="recommandThumUpDown(false)">
                    <i></i><span>没用</span>
                </div>
            </div>
        </div>

        <div class="search-result search-knowledge-result padding-sets" v-show="knowledgeListLength">
            <p class="search-total fellow-total search-bdr flexBox" :class="{'click-diable': knowledgeListLength <= knowledgeMax}" @click="viewKnowledgeList">
                <span class="flexItem">知识点({{ knowledgeListLength }})</span>
                <img src="/static/images/arrawRight.png" alt="" class="arrowImg" v-show="knowledgeListLength > knowledgeMax">
            </p>
            <section class="knowledge-list box_search" :class="$style['box_search']" v-for="(knowledge, index) in knowledgeList" v-if="index < knowledgeMax" @click="viewKnowledge(knowledge.KBInfoId,index)">
                <span class="search-item-title" v-html="knowledge.Title"></span>
                <div class='search-item-content' v-html="knowledge.Content"></div>
                <div class="analyse-info">
                    <span>{{ knowledge.TotalViewCount | validCount }}人浏览</span>
                    <span class="ml-10">{{ knowledge.TotalCollectionCount | validCount }}人收藏</span>
                </div>
            </section>
        </div>

        <div class="search-result search-faq-result padding-sets" v-show="faqListLength">
            <p class="search-total faq-total search-bdr flexBox" :class="{'click-diable': faqListLength <= faqMax}" @click="viewFAQList">
                <span class="flexItem">常见问题({{ faqListLength }})</span>
                <img src="/static/images/arrawRight.png" class="arrowImg" v-show="faqListLength > faqMax">
            </p>
            <section class="faq-list box_search" :class="$style['box_search']" v-for="(faq, index) in faqList" v-if="index < faqMax" @click="viewFAQ(faq.KBInfoId,index)">
                <span class="search-item-title" v-html="faq.Title"></span>
                <div class="search-item-content" v-html="faq.Content"></div>
                <div class="analyse-info">
                    <span>{{ faq.TotalViewCount | validCount }}人浏览</span>
                    <span class="ml-10">{{ faq.TotalCollectionCount | validCount }}人收藏</span>
                </div>
            </section>
        </div>

        <div class="search-result search-attachments-result padding-sets" v-show="attachmentListLength">
            <p class="search-total faq-total search-bdr flexBox attachment-border" :class="{'click-diable': attachmentListLength < attachmentMax}" @click="viewAttachmentList">
                <span class="flexItem">附件({{ attachmentListLength }})</span>
                <img src="/static/images/arrawRight.png" class="arrowImg" v-show="attachmentListLength >= attachmentMax">
            </p>
            <section class="attachment-list box_search " :class="$style['box_search']" v-for="(attachment, index) in attachmentList" v-if="index < attachmentMax" @click="attachmentVisited(index)">
                <div class="search-list-item" @click="openFile(attachment.Url, attachment.Name)">
                    <i class="attachment-link"></i>
                    <span v-html="attachment.Name" class="attachment-content" :class="{'attchment-visited':attachment.visited==true}"></span>
                </div>
            </section>
        </div>

        <div class="search-noresult-tip" v-show="unSatisfyTip">
            <div class="noresult"></div>
            <span>没找到想要的内容?</span>
            <span class="noresult-text" @click="actionSeekHelp('Search')">求助</span>
        </div>
    </div>
</template>

<script>

import wantedBar from './bottomBar'
import store from '@/store/index'
import dsBridge from '@/utils/dsbridge'
import { HOME, SEARCH, COMMON } from '@/api'
import commonMixin from '@/utils/commonMixin'

export default {
    name: 'searchKnowledge',
    mixins: [ commonMixin ],
    components: { wantedBar },
    data() {
        return {
            scrollTop: 0,
            showBottomBar: false,  //这个不是控制显示隐藏的值，只是为了记录上一次的显示隐藏
            selectedTopic:'全部',
            keywords: '',
            constantSearch: false,  // 是否为连续实时搜索 连续输入关键词为true 手动点击搜索为false
            userAction: '',
            faqMax: 3,
            knowledgeMax: 4,
            attachmentMax: 3,
            similarWordList: [],
            faqList: [],
            knowledgeList: [],
            attachmentList: [],
            faqListLength: null,
            knowledgeListLength: null,
            attachmentListLength: null,
            actionSearch: false,
            unSatisfyTip: false,
            topicSelected: false,
            selectNodeId: '',
            placeholder: '你有什么想了解的？',
            scopeLists: [],
            atlas: '',  // 知识图谱
            IsCfIntent: false,  // 是否触发意图
            IsCfKgService: false,  // 是否触发图谱
            IsCfSimilar: false,  // 是否触发相似词
            reportP: null,  // promise对象
            LogId: null, // 日志ID
            MovementsDefault: {  // 用户在搜索后的行为
                NA: null,  // 停留页面一分钟以上 或 没有以下几种行为之一
                Simiary: null,  // 点击相似词进入新搜索
                Knowledge: null,  // 点击优先显示的`knowledgeMax`条知识点
                MoreKnowledge: null,  // 点击更多知识点结果
                FAQ: null,  // 点击优先显示的`faqMax`条常见问题
                MoreFAQ: null,  // 点击更多常见问题结果
                Attachment: null,  // 点击优先显示的`attachmentMax`条附件
                MoreAttachment: null,  // 点击更多附件结果
                Feedback: null,  // 没有结果的时候，点击“我要问”
                DetailID: null  // 用户点击的FAQ/Knowledge ID
            },
            Movements: [],
            MovementsDetailId: null,

            //搜索历史
            searchHistoryList:localStorage.searchHistory ? JSON.parse(localStorage.searchHistory) : []
        }
    },
    computed: {
        authType() {
            return localStorage.AUTH_TYPE
        },

    },
    mounted() {
        sessionStorage.nio_question = ''
        this.getScopeList()
        this.$nextTick(() => {
            this.$refs.searchinput.focus()
        })
        document.getElementById('search-page').addEventListener('scroll', this.scrollHandle, false)
    },
    activated() {
        document.getElementById('search-page').addEventListener('scroll', this.scrollHandle, false)

        document.getElementById('search-page').scrollTop = this.scrollTop
        this.showBottomBar ? this.$store.commit('setBottomBar', this.showBottomBar) : this.$store.commit('setBottomBar', '')
        // Fixed 从 FAQ详情页 返回到 Search页 再点击另一条FAQ时 不记录
        // this.LogId = null
    },

    methods: {
        scrollHandle() {
            // 如果没有调用搜索   return
            if (!this.actionSearch) return;
            let windowH = document.getElementById('search-page').clientHeight;
            let pageH = document.getElementById('search-knowledge-box').offsetHeight;
            let windowScrollTop = document.getElementById('search-page').scrollTop; // 滚动高度
            let leftTop = pageH - windowH - windowScrollTop;   //剩余高度(页面底部与视口底部的距离)
            // 如果剩余高度小于.18倍屏高 或者  滚动高度超过 .82倍屏高  不要问为什么是 0.18 ， 问就是sixsixsix
            // if (leftTop < 0.18*windowH || windowScrollTop> 0.82*windowH) {
            if (leftTop < 0.18 * windowH) {   //这里只用剩余高度来判断，因为没有分页
                this.$store.commit('setBottomBar', 'slide-up');
            }
        },
        getScopeList() {
            HOME.GetNodeListMap().then((res) => {
                let all = {
                    CaaId: "00000000-0000-0000-0000-000000000000",
                    Name: "全部",
                    NodeId: "",
                    Selected: false
                }
                res.Data && (this.scopeLists = res.Data.ParentList)
                this.scopeLists.unshift(all)
            })
        },
        selectTopic(topic) {  // 选中专题
            if(topic.NodeId == this.selectNodeId || (!this.selectNodeId && !topic.NodeId)) return
            this.selectNodeId = topic.NodeId
            this.selectedTopic = topic.Name
            this.placeholder = topic.Name === '全部' ? '你有什么想了解的？' : '搜索' + topic.Name
            this.$refs.searchinput.focus()
            this.$nextTick(()=>{
                this.topicSelected = false
                if(this.keywords && this.keywords.trim().length) this.Searching()
                
            })
        },
        openFile(src, htmlFileName) {
            // 这里有问题 ajax和跳转页面冲突了 ajax会被中断
            // this.MovementsReport('Attachment')

            let lastIndex = htmlFileName.lastIndexOf('.')  // 文件名最后一个点的索引
            let fileName = htmlFileName.substring(0, lastIndex)  // 带有html标签的文件名
            let fileType = htmlFileName.substring(lastIndex + 1)  // 文件类型
            let formatFileName = htmlFileName.replace(new RegExp(/<.+?>/, 'g'), '')  // 文件名

            if (this.authType === "APOLLO") {
                dsBridge.call('ApolloApp.invokeAsyn', {
                    methodName: "openFile",
                    params: {
                        "url": src,
                        "suffix": fileType,
                        "file_name": formatFileName
                    }
                }, function (res) {
                    console.log('error', res);
                })
                return
            }
            if (this.authType === 'TOOLKIT') {
                // docs: https://confluence.nevint.com/pages/viewpage.action?pageId=165983913
                dsBridge.call('NIOMateBridge.openFileByInstalledApp', {
                    "url": src
                }, function (result) {
                    console.log('---', result)
                })
                return
            }
            // window.open(src)
            location.href = src
        },
        searchFocus() {
            document.querySelector('#search-page').addEventListener('touchmove', this.disableScroll, false)
        },
        SearchBlur() {
            document.querySelector('#search-page').removeEventListener('touchmove', this.disableScroll, false)
        },
        disableScroll(event) {
            event.preventDefault()
        },
        recommandThumUpDown(upDown) {
            if (upDown) {  // 赞
                if (this.userAction) return
                this.userAction = 'recommand-thumUp'
            } else {  // 踩
                if (this.userAction) return
                this.userAction = 'recommand-thumDown'
            }
            try {
                MtaH5.clickStat('value_of_faq', {'useful': String(upDown), 'time': this.$formatTime(), 'searchcontent': this.keywords, 'adacount': localStorage.ADAccount})
            } catch (err) {
            }
            store.commit('SetAndCallToast', '感谢反馈')

        },
        getSearch() {  // 点击搜索
            if (this.keywords.length > 0) {
                this.Searching();
            }
        },
        Searching(similarWord) {
            console.log(this.keywords, 'emit...')
            this.keywords = this.keywords.trim();
            if (similarWord) {  //如果有相似词
                this.keywords = similarWord.trim();
                this.MovementsReport('Simiary')
            }
            if (!this.keywords.replace(/^\s+|\s+$/g, '') || (this.keywords.length <= 1) && !/[\u4E00-\u9FA5]/.test(this.keywords)) {
                store.commit('SetAndCallToast', '请再给多点信息吧')
                return
            }
            this.unSatisfyTip = false
            if (!this.constantSearch) {  // 输入关键词实时触发搜索 不失焦
                this.$refs.searchinput.blur()
            }
            this.userAction = ''
            this.$store.commit('setBottomBar', '')
            this.actionSearch = true
            let SP = new Promise((resolve, reject) => {
                SEARCH.SearchingAdvice({
                    Keywords: this.keywords.trim()
                }).then((res) => {
                    this.similarWordList = res.Data ? res.Data.SimilarWordList : []
                    this.IsCfSimilar = !!this.similarWordList.length
                    resolve()
                })
            })
            let FP = new Promise((resolve, reject) => {
                SEARCH.SearchingFaq({
                    Keywords: this.keywords.trim(),
                    PageIndex: 1,
                    PageSize: 100,
                    NodeId: this.selectNodeId
                }).then((res) => {
                    this.faqList = (res.Data && res.Data.List) || []
                    this.atlas = res.Data.OutputText
                    this.faqListLength = (res.Data && res.Data.TotalCount) || 0
                    this.IsCfIntent = res.Data.IsCfIntent
                    this.IsCfKgService = res.Data.IsCfKgService

                    try {
                        MtaH5.clickStat('searchresult', {'intention': String(!!this.atlas), 'time': this.$formatTime(), 'searchcontent': this.keywords, 'adacount': localStorage.ADAccount})
                    } catch (err) {
                    }
                    resolve()
                })
            })
            let KP = new Promise((resolve, reject) => {
                SEARCH.SearchingKnowledge({
                    Keywords: this.keywords.trim(),
                    PageIndex: 1,
                    PageSize: 100,
                    NodeId: this.selectNodeId
                }).then((res) => {
                    this.knowledgeList = (res.Data && res.Data.List) || []
                    this.knowledgeListLength = (res.Data && res.Data.TotalCount) || 0
                    resolve()
                })
            })
            let AP = new Promise((resolve, reject) => {
                SEARCH.SearchingAttachment({
                    Keywords: this.keywords.trim(),
                    PageIndex: 1,
                    PageSize: 15,
                    NodeId: this.selectNodeId
                }).then((res) => {
                    this.attachmentList = (res.Data && res.Data.List) || []
                    this.attachmentListLength = (res.Data && res.Data.TotalCount) || 0
                    resolve()
                })
            })
            Promise.all([FP, KP, AP]).then(() => {
                // 记录搜索历史
                let searchHistory = localStorage.searchHistory ? JSON.parse(localStorage.searchHistory) : [];
                searchHistory.unshift(this.keywords.trim());
                searchHistory = [...new Set(searchHistory)].slice(0,10)

                localStorage.setItem('searchHistory',JSON.stringify(searchHistory))

                //------------------------重置提问栏-----------------------
                // let clientH = document.querySelector('#app').clientHeight
                // let boxH = document.querySelector('.search-knowledge-box').clientHeight
                // this.boxScrolling = boxH - clientH >= 0
                // this.showWanted = false
                //--------------------------------------------------------

                this.unSatisfyTip = (!this.faqListLength && !this.knowledgeListLength && !this.attachmentListLength)

                // 如果没有结果
                if (this.unSatisfyTip) return;
                // 如果有结果，延迟判断是否有滚动，如果没有滚动，就让底部提问栏渐显上来
                let timer = setTimeout(() => {
                    let windowH = document.getElementById('search-page').clientHeight;
                    let pageH = document.getElementById('search-knowledge-box').offsetHeight;
                    // 如果没有出现滚动
                    if (pageH <= windowH) {
                        this.$store.commit('setBottomBar', 'fade-up-delay');
                    }
                    clearTimeout(timer)
                }, 1000)
            })

            // 搜索埋点日志 需等待 SP 和 FP 的接口返回
            Promise.all([SP, FP]).then(() => {
                this.SearchReport()
            })

        },
        ClearSearch() {
            this.keywords = ''
            this.similarWordList = []
            this.atlas = ''
            this.userAction = ''
            this.$refs.searchinput.focus()
            this.faqList = []
            this.knowledgeList = []
            this.attachmentList = []
            this.faqListLength = null
            this.knowledgeListLength = null
            this.attachmentListLength = null
            this.actionSearch = false
            this.unSatisfyTip = false
            this.searchHistoryList = JSON.parse(localStorage.searchHistory)
            // reset variable
            // this.selectNodeId = ''
            this.placeholder = '你有什么想了解的？'
            //重置提问栏
            this.$store.commit('setBottomBar', '');
        },
        searchingHistory(historys){
            this.keywords = historys
            this.Searching()
        },
        clearSearchHistory(){
            localStorage.removeItem('searchHistory');
            this.searchHistoryList = []
        },
        attachmentVisited(index) {
            this.$set(this.attachmentList[index], 'visited', true)
        },
        SearchReport() {  // 用户搜索记录埋点
            COMMON.AddSearchMovementData({
                Content: this.keywords.trim(),
                NodeId: this.selectNodeId,
                IsIntent: this.IsCfIntent,
                IsKgService: this.IsCfKgService,
                IsSimilar: this.IsCfSimilar
            }).then((res) => {
                // 触发过 MovementsReport
                this.reportP && this.reportP.then(() => {
                    this.LogId = res.Data && res.Data.LogId
                    console.log('add1:', this.LogId)
                })
                // 没触发过 MovementsReport
                if (!this.reportP) {
                    this.LogId = res.Data && res.Data.LogId
                    console.log('add2:', this.LogId)
                }
            })
        },
        MovementsReport(movement, numberIndex) {  // 用户行为记录埋点

            // LogId 为空 不记录数据
            if (!this.LogId) return

            let ajaxParam = {
                LogId: this.LogId,
                MovementEnum: movement,
                KBInfoId: this.MovementsDetailId
            }
            if (numberIndex !== undefined) {
                ajaxParam.clicknumber = numberIndex
            }
            this.reportP = new Promise((resolve, reject) => {
                COMMON.UpdateSearchMovementData(ajaxParam).then((res) => {
                    resolve()
                })
            })
        },
        viewKnowledge(KBInfoId, numberIndex) {  // 进入Knowledge详情页

            this.MovementsDetailId = KBInfoId
            this.MovementsReport('Knowledge', numberIndex)

            this.$router.push({
                name: 'knowledge',
                params: {uuid: KBInfoId}
            })
        },
        viewKnowledgeList() {  // 进入Knowledge列表页

            this.MovementsReport('MoreKnowledge')

            this.$router.push({
                path: '/search/knowledgeList',
                query: {searchKey: this.keywords, searchNodeId: this.selectNodeId, LogId: this.LogId}
            })
        },
        viewFAQ(KBInfoId, numberIndex) {  // 进入FAQ详情页

            this.MovementsDetailId = KBInfoId
            this.MovementsReport('FAQ', numberIndex)

            this.$router.push({
                name: 'faq',
                params: {uuid: KBInfoId}
            })
        },
        viewFAQList() {  // 进入FAQ列表页

            this.MovementsReport('MoreFAQ')

            this.$router.push({
                path: '/search/faqList',
                query: {searchKey: this.keywords, searchNodeId: this.selectNodeId, LogId: this.LogId}
            })
        },
        viewAttachmentList() {  // 进入附件列表页

            this.MovementsReport('MoreAttachment')

            this.$router.push({
                path: '/search/attachmentList',
                query: {searchKey: this.keywords, searchNodeId: this.selectNodeId}
            })
        }
    },
    watch: {
        '$route'(to, from) {
            // 从首页搜索框 和 知识目录搜索框 进入的路由不缓存页面数据
            if (from.name !== 'home' && from.name !== 'treeMenu') return
            this.ClearSearch()
        },
        keywords() {
            if (!this.keywords.replace(/^\s+|\s+$/g, '') || (this.keywords.length <= 1) && !/[\u4E00-\u9FA5]/.test(this.keywords)) {
                return
            }
            // 标明是实时搜索
            this.constantSearch = true
            this.Searching()
            // sessionStorage.nio_question = this.keywords || (sessionStorage.nio_question ? sessionStorage.nio_question : '')
            sessionStorage.nio_question = this.keywords
        }
    },
    beforeRouteLeave(to, from, next) {
        this.scrollTop = document.getElementById('search-page').scrollTop;
        this.showBottomBar = this.$store.getters.bottomBar;
        this.$store.commit('setBottomBar', '')
        document.getElementById('search-page').removeEventListener('scroll', this.scrollHandle)
        next()
    }
}
</script>

<style lang="scss" type="text/scss" scoped>
    .search-knowledge-box {
        padding-bottom: j(180);
    }

    .search-input-box {
        margin: 0 j(50);
        height: j(120);
        position: relative;
        top: 0;
        z-index: 1;
        display: flex;
        align-items: center;

        &:after {
            @include thin-bb (#cdced4);
        }

        .arrow-click {
            padding-left: j(50);
            margin-left: j(-50);
            margin-right: j(-50 + 14);
            display: inline-block;
            width: j(14 + 50);
            height: 100%;
            background: url(/static/images/arrowLeft.svg) no-repeat;
            background-size: 25% 25%;
            background-position: center center;
        }

        .topic-select {
            width: j(184);
            height: j(40);
            color: #363C54;
            font-size: j(32);
            border-right: 1px solid #DADCDE;
            margin-right: j(30);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            position: relative;
            padding-right: j(50);
            box-sizing: border-box;
            i {
                position: absolute;
                right: j(15);
                top: 50%;
                transform: translateY(-50%);
                width: j(20);
                height: j(20);
                background: url("/static/images/icon/trangle_full_gray.png") no-repeat;
                background-size: contain;
            }
        }
        .search-box {
            flex: 1;
            height: 100%;
            input::-webkit-input-placeholder {
                // line-height: j(60);
                font-size: j(32);
                font-weight: 700;
                color: #9B9DA9;
            }

            input {
                caret-color: #00bebe;
                color: #363c54;
                font-size: j(32);
                // line-height: j(60);
                font-weight: 700;
                width: 100%;
                height: 100%;
                padding-right: j(33);
                transition: all .2s linear;
            }

            .placeholder-padding {
                padding-left: j(12);
            }
        }

        .search-close {
            font-size: j(32);
        }

        .search-btn {
            height: 100%;
            font-size: j(32);
            color: #00BEBE;
            display: flex;
            align-items: center;
            margin-left: j(20);
            background: #fff;
        }

        .search-btn-disabled {
            color: #CDCED4;
        }
    }

    .search-knowledge-tip {
        margin-top: j(60);

        .tip-head {
            margin-bottom: j(17);
            font-size: j(32);
            font-weight: bold;
            color: #040b29;
        }

        .tip-content {
            font-size: j(28);
            color: #9b9da9;
        }
    }

    .search-history{
        padding: j(60) j(50);
        h5{
            height: j(40);
            font-size:j(28);
            font-weight:400;
            color:rgba(4,11,41,1);
            display: flex;
            align-items: center;
            justify-content: space-between;
            i{
                width: j(28);
                height: j(32);
                display: block;
                background: url("/static/images/icon/garbage.png") no-repeat;
                background-size: contain;
            }
        }
        .history-list{
            display: flex;
            flex-wrap: wrap;
            margin-left: j(-20);
        }
        .history-list-item{
            margin-top: j(40);
            height: j(60);
            background-color: #F5F7F7;
            padding: 0 j(30);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: j(30);
            margin-left: j(20);
            color: #9B9DA9;
            font-size: j(28);

        }
    }
    .topic-select-mask{
        position: fixed;
        bottom: 0;
        left: 0;
        top: 0;
        right: 0;
        background-color: rgba(0,0,0,.3);
        z-index: 3;
    }
    .topic-select-mask-anim-enter,.topic-select-mask-anim-leave-to{
        opacity: 0;
    }
    .topic-select-mask-anim-enter-active{
        transition: all .3s linear;
    }
    .topic-select-mask-anim-leave-active{
        transition: all .3s linear .3s;
    }
    .topic-select-list-wrapper {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: #fff;
        z-index: 4;
        padding-bottom: j(80);
        .topic-head {
            height: j(120);
            line-height: j(120);
            font-size: j(32);
            color: #363C54;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: j(40);
            i{
                display: block;
                height: j(48);
                width: j(48);
                background: url("/static/images/icon/Rectangle@2x.png") no-repeat;
                background-size: contain;
            }
        }
        .list-wrapper{
            max-height: j(830);
            overflow-y: scroll;
        }
        .topic-lists {
            font-size: 0;
            display: flex;
            flex-wrap: wrap;
            margin-left: j(-28);
            padding-bottom: j(40);
        }
        .topic-list-item {
            margin-left: j(28);
            margin-bottom: j(40);
            padding-left: j(29);
            padding-right: j(29);
            box-sizing: border-box;
            height: j(60);
            min-width: j(197);
            border: 1px solid #F0F1F2;
            overflow: hidden;
            text-align: center;
            font-size: j(28);
            color: #9b9da9;
            border-radius: j(30);
            justify-content: center;
        }
        .topic-list-item-active{
            border-color: #00BEBE;
            color: #00BEBE;
        }
    }
    .topic-select-list-wrapper-anim-enter,.topic-select-list-wrapper-anim-leave-to{
        transform: translateY(100%);
        opacity: 0;
    }
    .topic-select-list-wrapper-anim-enter-active{
        transition: all .3s linear;
    }
    .topic-select-list-wrapper-anim-leave-active{
        transition: all .3s linear .3s;
    }
    .search-result {
        font-size: j(28);
        color: #363c54;
        &.search-advice {
            padding-top: j(40);
            padding-bottom: j(40);
            border-bottom: j(20) solid #f0f1f2;
            font-size: j(28);
            color: rgba(54, 60, 84, 1);

            span {
                color: #00bebe;
            }
        }

        &.search-atlas-result {
            border-bottom: j(20) solid #f0f1f2;

            .atlas {
                padding: j(40) 0;
                font-size: j(32);
                color: #363C54;
            }

            .thumb-up-down {
                width: 100%;
                display: flex;
                justify-content: center;
                padding-bottom: j(40);

                .thumb-down,
                .thumb-up {
                    width: j(120);
                    height: j(120);
                    border: 1px solid #F0F1F2;
                    border-radius: 50%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    color: #9B9DA9;
                    font-size: j(20);
                    line-height: j(18);

                    i {
                        display: block;
                        width: j(44);
                        height: j(44);
                        margin-bottom: j(10);
                        background: url("/static/images/icon/recommend-down-nor.png") no-repeat;
                        background-size: cover;
                    }
                }

                .thumb-up {
                    margin-right: j(60);

                    i {
                        background-image: url("/static/images/icon/recommend-up-nor.png");
                    }
                }
            }

            .recommand-thumUp {
                .thumb-down,
                .thumb-up {
                    border: 1px solid #F7F7F8;
                    color: #F0F1F2;

                    i {
                        background-image: url("/static/images/icon/recommend-down-disable.png");
                    }
                }

                .thumb-up {
                    border: 1px solid #00BEBE;
                    color: #00BEBE;

                    i {
                        background-image: url("/static/images/icon/recommend-up-sel.png");
                    }
                }
            ;
            }

            .recommand-thumDown {
                .thumb-down,
                .thumb-up {
                    border: 1px solid #00BEBE;
                    color: #00BEBE;

                    i {
                        background-image: url("/static/images/icon/recommend-down-sel.png");
                    }
                }

                .thumb-up {
                    border: 1px solid #F7F7F8;
                    color: #F0F1F2;

                    i {
                        background-image: url("/static/images/icon/recommend-up-disable.png");
                    }
                }
            ;
            }
        }

        &.search-faq-result {
            border-top: j(20) solid #f0f1f2;
        }

        &.search-attachments-result {
            border-top: j(20) solid #f0f1f2;
        }

        .search-total {
            padding: j(40) 0;
            font-size: j(32);

            &.click-diable {
                pointer-events: none;
            }

            .arrowImg {
                // width:j(34);
                width: j(38);
                display: block;
            }

            .arrow-right {
                width: j(20);
                height: j(20);
                border-top: 1px solid;
                border-right: 1px solid;
                box-sizing: border-box;
                transform: translateX(j(-6)) rotate(45deg);
            }
        }

        .attachment-list,
        .faq-list,
        .knowledge-list {
            font-weight: 400;
            padding: j(40) 0;
            word-break: break-word;
        }

        .attachment-list {
            padding: j(20) 0;
        }

        .faq-list,
        .knowledge-list {
            position: relative;

            &:after {
                @include thin-bb (#f0f1f2);
            }
        }

        .attachment-border {
            position: relative;

            &:after {
                @include thin-bb (#f0f1f2);
            }
        }

        // .search-bdr {
        //     position: relative;
        //     &:after {
        //         @include thin-bb(#f0f1f2);
        //     }
        // }
        .highlight {
            color: #00bcbc;
        }

        .search-list-item {
            display: flex;
            align-items: center;
            font-size: j(32);
            color: #00BCBC;
        }

        .attchment-visited {
            color: #009292 !important;
            // background:#ccc;
        }

        .attachment-link {
            display: inline-block;
            height: j(41);
            width: j(41);
            margin-right: j(13);
            background: url("../../../static/images/attachment_link.png") no-repeat;
            background-size: 100% 100%;
        }

        .attachment-content {
            width: 100%;
            font-size: j(32);
            color: #00BCBC;
            display: block;

            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
            display: -webkit-box;
            /*!autoprefixer: off */
            -webkit-box-orient: vertical;
            /*autoprefixer: on */
            -webkit-line-clamp: 2;
        }

        .search-item-title {
            font-size: j(28);
            color: #363C54;
            display: block;
        }

        .search-item-content {
            font-size: j(28);
            margin-top: j(20);
            color: #696D7F;

            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
            display: -webkit-box;
            /*!autoprefixer: off */
            -webkit-box-orient: vertical;
            /*autoprefixer: on */
            -webkit-line-clamp: 2;

        }
        .analyse-info {
            margin-top: j(20);
            font-size: j(24);
            color: #9B9DA9;
        }
        .ml-10 {
            margin-left: 10px;
        }
    }

    .search-noresult-tip {
        padding-top: j(120);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .noresult {
            background: url("/static/images/empty/no-wanted.png") no-repeat;
            background-size: cover;
            background-position: center;
            width: j(642);
            height: j(448);

        }
        span{
            color: #9B9DA9;
            font-size: j(32);
        }
        .noresult-text {
            color: #00bebe;
            margin-top: j(60);
        }
    }

    .padding-sets {
        padding-left: j(50);
        padding-right: j(50);
    }


</style>
<style lang="scss" module>
    .box_search strong {
        color: #00bebe;
    }
</style>



// WEBPACK FOOTER //
// src/views/search/searchKnowledge.vue